export enum GoalUnit {
  CO2E = "CO2E",
  INTENSITY = "INTENSITY",
  PERCENTAGE = "PERCENTAGE"
}
